import React from 'react';
import { CheckCircle, MapPin, Phone, Mail, Globe, Users } from 'lucide-react';

const ReviewStep = ({ formData }) => {
    return (
        <div className="form-section">
            <h3>
                <CheckCircle size={24} />
                Review Venue Details
            </h3>
            <p>Please review the information below before creating the venue.</p>

            <div className="featured-card">
                <div className="featured-row">
                    <span className="featured-title">{formData.name}</span>
                    <span className="upload-pill">{formData.type}</span>
                </div>
                <div className="featured-subtext">{formData.description}</div>

                <div className="venue-info-list" style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div className="hint-text">
                        <Users size={14} /> Capacity: {formData.capacity}
                    </div>
                    <div className="hint-text">
                        <MapPin size={14} />
                        {formData.street}, {formData.city}, {formData.state} {formData.zipCode}, {formData.country}
                    </div>
                </div>
            </div>

            <div className="form-grid" style={{ marginTop: '24px' }}>
                <div className="wizard-callout">
                    <strong>Contact Info</strong>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
                        {formData.phone && <div className="hint-text"><Phone size={14} /> {formData.phone}</div>}
                        {formData.email && <div className="hint-text"><Mail size={14} /> {formData.email}</div>}
                        {formData.website && <div className="hint-text"><Globe size={14} /> {formData.website}</div>}
                    </div>
                </div>

                <div className="wizard-callout">
                    <strong>Features & Amenities</strong>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                        {formData.hasBalcony && <span className="upload-pill">Balcony</span>}
                        {formData.hasVipSection && <span className="upload-pill">VIP Section</span>}
                        {formData.amenities.map(a => (
                            <span key={a} className="upload-pill">{a}</span>
                        ))}
                    </div>
                    <div style={{ marginTop: '12px' }}>
                        <strong>Accessibility</strong>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                            {formData.accessibilityFeatures.map(a => (
                                <span key={a} className="upload-pill">{a}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewStep;
